import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DashboardCustomerComponent } from '../dashboard/dashboard-customer.component';
import { DashboardEngineiusComponent } from '../dashboard/dashboard-engineius.component';
import { DashboardSupplierComponent } from '../dashboard/dashboard-supplier.component';
import { HomeComponent } from './home.component';
import { EngineiusHomepageComponent } from '../dashboard/EngineiusHomepage/engineius-homepage.component';

const routes: Routes = [{ path: '', component: HomeComponent, data: { title: 'Home' } }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class HomeRoutingModule {}

@NgModule({
  imports: [
    HomeRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [
    HomeComponent,
    DashboardEngineiusComponent,
    DashboardCustomerComponent,
    DashboardSupplierComponent,
    EngineiusHomepageComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeModule {}
